import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import { servicesData } from '../Component/NavBarFooter/dummayData';
import Banner from '../Component/Services/Banner';
import Footer from '../Component/NavBarFooter/Footer';
import DetailSection from '../Component/Services/DetailSection';

// import NavBar from '../Component/NavBarFooter/NavBar';

function Services() {
    
    const [seviceData, setSeviceData] = useState({});
    useEffect(() => {
        const path = window.location.pathname?.split('/')[1];
        
        servicesData.filter((item) => {
            if (item.slug === path) {
                setSeviceData(item);
                // return true;
            }
            // return false;
        }
    );

    }, [window.location.pathname]);
    // console.log(seviceData);
    
  return (
    <div>
        <NavBar/>
        <Banner data={seviceData}/>
        <DetailSection data={seviceData}/>
        <Footer />
           </div>
  )
}

export default Services